import React from "react"
import Button from "aldoo-ra/Button"
import Tooltip from "aldoo-ra/Tooltip"
import { showNotification } from "aldoo-ra/Notification"
import { ClipboardDocumentCheckIcon, DocumentDuplicateIcon, Cog6ToothIcon } from "@heroicons/react/24/outline"

export default function CopyPaste({ setLocalFieldValues, localFieldValues, onSettingsClick, showSettings = false }) {
  return (
    <div className="flex gap-1">
      <Tooltip content="Paste field values from clipboard" position="top">
        <Button
          variant="admin_icon"
          className="text-admin_text"
          onClick={async () => {
            try {
              const clipboard = await navigator.clipboard.readText()
              const text = clipboard.trim()

              if (!text) {
                showNotification({
                  message: "Clipboard is empty",
                  className: "bg-admin_error",
                })
                return
              }

              const copiedValues = JSON.parse(text)

              // Keep _id if it exists (allows updating existing content types)
              // Only delete _id if explicitly creating a copy/duplicate
              // delete copiedValues._id

              setLocalFieldValues({
                ...copiedValues,
              })

              //notify the user
              showNotification({
                message: "Pasted",
              })
            } catch (error) {
              showNotification({
                message: "Invalid JSON in clipboard. Please copy valid JSON content.",
                className: "bg-admin_error",
              })
              console.error("Paste error:", error)
            }
          }}
        >
          <ClipboardDocumentCheckIcon className="w-5 h-5" />
        </Button>
      </Tooltip>

      <Tooltip content="Copy field values to clipboard" position="top">
        <Button
          variant="admin_icon"
          className="text-admin_text"
          onClick={() => {
            navigator.clipboard.writeText(JSON.stringify(localFieldValues))
            showNotification({
              message: "Copied",
            })
          }}
        >
          <DocumentDuplicateIcon className="w-5 h-5" />
        </Button>
      </Tooltip>

      {showSettings && onSettingsClick && (
        <Tooltip content="Content settings" position="top">
          <Button
            variant="admin_icon"
            className="text-admin_text"
            onClick={onSettingsClick}
          >
            <Cog6ToothIcon className="w-5 h-5" />
          </Button>
        </Tooltip>
      )}
    </div>
  )
}
